/**
 * checkinAdminOps — /api/checkin/admin/operations/* client.
 *
 * Uses the Check In admin JWT (localStorage 'checkin.token'). All routes
 * are Phase 1.5 Operations Completion Patch endpoints.
 */
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const BASE = `${BACKEND}/api/checkin/admin/operations`;

function _token() {
  try { return localStorage.getItem("checkin.token") || ""; } catch { return ""; }
}

async function _req(path, { method = "GET", body = null, params = null } = {}) {
  let url = `${BASE}${path}`;
  if (params) {
    const p = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") p.set(k, String(v));
    });
    const q = p.toString();
    if (q) url += `?${q}`;
  }
  const res = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${_token()}`,
    },
    body: body != null ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = null;
    try { detail = (await res.json()).detail; } catch { /* ignore */ }
    const err = new Error(typeof detail === "string" ? detail :
                            (detail?.message || `HTTP ${res.status}`));
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return res.json();
}

export const checkinAdminOps = {
  // Settings
  getSettings:       ()        => _req("/settings"),
  patchSettings:     (changes) => _req("/settings", { method: "PATCH", body: { changes } }),
  restoreDefaults:   ()        => _req("/settings/restore-defaults", { method: "POST" }),
  settingsAudit:     (limit=100) => _req("/settings/audit", { params: { limit } }),

  // Twilio
  twilioHealth:      ()        => _req("/twilio/health"),
  twilioTestSend:    (phone, allow_dev_mode=false) => _req("/twilio/test-send",
    { method: "POST", body: { phone, allow_dev_mode } }),
  twilioTestAudit:   (limit=50) => _req("/twilio/test-audit", { params: { limit } }),

  // Analytics
  analytics:         (params={}) => _req("/analytics", { params }),
  migrationSummary:  ()        => _req("/migration/summary"),

  // Users
  searchUsers:       (q)       => _req("/users/search", { params: { q } }),
  resetComplimentary: (user_id, reason) => _req("/users/reset-complimentary",
    { method: "POST", body: { user_id, reason } }),

  // Merge queue
  listMergeReviews:  (status)  => _req("/merge-reviews", { params: { status } }),
  mergeAction:       (id, body) => _req(`/merge-reviews/${encodeURIComponent(id)}/action`,
    { method: "POST", body }),

  // Audit trail
  auditTrail:        (limit=100, user_id) => _req("/audit-trail", { params: { limit, user_id } }),
};
